import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Courses from './pages/Courses';
import Students from './pages/Students';
import Instructors from './pages/Instructors';
import Directors from './pages/Directors';
import Profile from './pages/Profile';
import UserProfile from './pages/UserProfile';
import UserManagement from './pages/UserManagement';
import CourseDetail from './pages/CourseDetail';
import VerifyCertificate from './pages/VerifyCertificate';
import OnlineCourses from './pages/OnlineCourses';
import OnlineCourseDetail from './pages/OnlineCourseDetail';
import LessonView from './pages/LessonView';
import MyOnlineCourses from './pages/MyOnlineCourses';
import PendingUsers from './pages/PendingUsers';
import QuizEditor from './pages/QuizEditor';
import QuizTake from './pages/QuizTake';
import QuizGrading from './pages/QuizGrading';
import QuizAttempts from './pages/QuizAttempts';
import MyCertificates from './pages/MyCertificates';
import MyQuizHistory from './pages/MyQuizHistory';
import StudentDashboard from './pages/StudentDashboard';
import CourseForum from './pages/CourseForum';
import ForumTopic from './pages/ForumTopic';
import CourseChat from './pages/CourseChat';
import SurveyPage from './pages/SurveyPage';
import SurveyResults from './pages/SurveyResults';
import EmailTemplates from './pages/EmailTemplates';
import EmailTemplateEditor from './pages/EmailTemplateEditor';
import BillingHub from './pages/billing/BillingHub';
import BillingSettings from './pages/billing/BillingSettings';
import Clients from './pages/billing/Clients';
import Suppliers from './pages/billing/Suppliers';
import Products from './pages/billing/Products';
import SalesDocList from './pages/billing/SalesDocList';
import SalesDocEditor from './pages/billing/SalesDocEditor';
import { PurchaseOrderList, PurchaseOrderEditor } from './pages/billing/PurchaseOrders';
import Expenses from './pages/billing/Expenses';
import BillingDashboard from './pages/billing/Dashboard';
import PaymentReview from './pages/billing/PaymentReview';
import PreinscriptionForm from './pages/PreinscriptionForm';
import Preinscriptions from './pages/Preinscriptions';
import ProtectedRoute from './components/ProtectedRoute';
import PrivacyPolicyModal from './components/PrivacyPolicyModal';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './App.css';

const AppContent = () => {
  const { showPrivacyModal, acceptPrivacy } = useAuth();
  
  return (
    <>
      <PrivacyPolicyModal isOpen={showPrivacyModal} onAccept={acceptPrivacy} />
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify/:code" element={<VerifyCertificate />} />
        <Route path="/verify-certificate" element={<VerifyCertificate />} />
        <Route path="/preinscripcion/:courseType/:courseId" element={<PreinscriptionForm />} />
        <Route
            path="/preinscriptions"
            element={
              <ProtectedRoute>
                <Preinscriptions />
              </ProtectedRoute>
            }
          />
        <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses"
            element={
              <ProtectedRoute>
                <Courses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses/:courseId"
            element={
              <ProtectedRoute>
                <CourseDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/students"
            element={
              <ProtectedRoute>
                <Students />
              </ProtectedRoute>
            }
          />
          <Route
            path="/instructors"
            element={
              <ProtectedRoute>
                <Instructors />
              </ProtectedRoute>
            }
          />
          <Route
            path="/directors"
            element={
              <ProtectedRoute>
                <Directors />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/online-courses"
            element={
              <ProtectedRoute>
                <OnlineCourses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/online-courses/:courseId"
            element={
              <ProtectedRoute>
                <OnlineCourseDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lessons/:lessonId"
            element={
              <ProtectedRoute>
                <LessonView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-courses"
            element={
              <ProtectedRoute>
                <MyOnlineCourses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pending-users"
            element={
              <ProtectedRoute>
                <PendingUsers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz-editor/:quizId"
            element={
              <ProtectedRoute>
                <QuizEditor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz/:quizId"
            element={
              <ProtectedRoute>
                <QuizTake />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz-grading/:attemptId"
            element={
              <ProtectedRoute>
                <QuizGrading />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quiz-attempts/:quizId"
            element={
              <ProtectedRoute>
                <QuizAttempts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-certificates"
            element={
              <ProtectedRoute>
                <MyCertificates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-quiz-history"
            element={
              <ProtectedRoute>
                <MyQuizHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/student-dashboard"
            element={
              <ProtectedRoute>
                <StudentDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/forums/course/:courseId"
            element={
              <ProtectedRoute>
                <CourseForum />
              </ProtectedRoute>
            }
          />
          <Route
            path="/forums/topics/:topicId"
            element={
              <ProtectedRoute>
                <ForumTopic />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat/course/:courseId"
            element={
              <ProtectedRoute>
                <CourseChat />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-profile"
            element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-management"
            element={
              <ProtectedRoute>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          {/* Survey routes */}
          <Route path="/survey/:courseId" element={<SurveyPage />} />
          <Route
            path="/courses/:courseId/survey-results"
            element={
              <ProtectedRoute>
                <SurveyResults />
              </ProtectedRoute>
            }
          />
          {/* Email template routes */}
          <Route
            path="/email-templates"
            element={
              <ProtectedRoute>
                <EmailTemplates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/email-templates/:templateType"
            element={
              <ProtectedRoute>
                <EmailTemplateEditor />
              </ProtectedRoute>
            }
          />
          {/* Billing / Intranet */}
          <Route path="/billing" element={<ProtectedRoute><BillingHub /></ProtectedRoute>} />
          <Route path="/billing/settings" element={<ProtectedRoute><BillingSettings /></ProtectedRoute>} />
          <Route path="/billing/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
          <Route path="/billing/suppliers" element={<ProtectedRoute><Suppliers /></ProtectedRoute>} />
          <Route path="/billing/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
          <Route path="/billing/dashboard" element={<ProtectedRoute><BillingDashboard /></ProtectedRoute>} />
          <Route path="/billing/quotes" element={<ProtectedRoute><SalesDocList docType="quote" /></ProtectedRoute>} />
          <Route path="/billing/quotes/:id" element={<ProtectedRoute><SalesDocEditor docType="quote" /></ProtectedRoute>} />
          <Route path="/billing/delivery-notes" element={<ProtectedRoute><SalesDocList docType="delivery_note" /></ProtectedRoute>} />
          <Route path="/billing/delivery-notes/:id" element={<ProtectedRoute><SalesDocEditor docType="delivery_note" /></ProtectedRoute>} />
          <Route path="/billing/invoices" element={<ProtectedRoute><SalesDocList docType="invoice" /></ProtectedRoute>} />
          <Route path="/billing/invoices/:id" element={<ProtectedRoute><SalesDocEditor docType="invoice" /></ProtectedRoute>} />
          <Route path="/billing/purchase-orders" element={<ProtectedRoute><PurchaseOrderList /></ProtectedRoute>} />
          <Route path="/billing/purchase-orders/:id" element={<ProtectedRoute><PurchaseOrderEditor /></ProtectedRoute>} />
          <Route path="/billing/expenses" element={<ProtectedRoute><Expenses /></ProtectedRoute>} />
          <Route path="/billing/payment-review" element={<ProtectedRoute><PaymentReview /></ProtectedRoute>} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
      </>
    );
  };

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;